import React, { useState, useEffect } from "react";
import { defaultMailBody } from "../Constants";
import { toast } from "react-toastify";

const SendInvoiceModal = ({
  isOpen,
  onClose,
  onSend,
  invoice,
  defaultSubject = "",
  invoiceType = "invoices",
}) => {
  const [subject, setSubject] = useState(defaultSubject);
  const [body, setBody] = useState("");
  const [recipient, setRecipient] = useState("");
  const [emailError, setEmailError] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [bodyError, setBodyError] = useState("");

  // Reset form when modal is reopened
  useEffect(() => {
    if (isOpen) {
      setSubject(defaultSubject);
      const tempBody = defaultMailBody(invoice, invoiceType);
      setBody(tempBody);
      // Reset error states when opening
      setEmailError("");
      setSubjectError("");
      setBodyError("");
    }
  }, [isOpen, defaultSubject, invoice, invoiceType]);

  useEffect(() => {
    // Adjust textareas height dynamically.
    const emailBodyTextArea = document.getElementById("emailBody");
    if (emailBodyTextArea) {
      emailBodyTextArea.style.height = "auto";
      emailBodyTextArea.style.height = `${emailBodyTextArea.scrollHeight}px`;
    }
  }, [body]);

  if (!isOpen) return null;

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSend = () => {
    let valid = true;
    if (!recipient.trim()) {
      valid = false;
      toast.error("Recipient email is required.");
    }
    if (!subject.trim()) {
      setSubjectError("Subject is required.");
      valid = false;
    } else {
      setSubjectError("");
    }
    if (!body.trim()) {
      setBodyError("Email body is required.");
      valid = false;
    } else {
      setBodyError("");
    }
    if (!validateEmail(recipient)) {
      setEmailError("Please enter a valid email address.");
      valid = false;
    } else {
      setEmailError("");
    }
    if (!valid) return;

    onSend({ subject, body, recipient });
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setRecipient(email);

    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center scrollable overflow-y-auto justify-center z-40">
      <div className="bg-tier-primary dark:bg-tier-primary-dark dark:border-gray-600 border text-color p-6 rounded-lg shadow-md w-full max-w-4xl">
        <h2 className="text-xl font-boldmb-4">Send Invoice via Email</h2>
        <div className="w-2/3 border-t-4 rounded-lg border-tier-secondary my-4"></div>
        <div className="mb-4">
          <label className="block">Recipient Email</label>
          <input
            type="email"
            value={recipient}
            onChange={handleEmailChange}
            placeholder="example@xyz.com"
            className={`w-full px-3 py-2 mt-1 custom-input border rounded-md focus:outline-none focus:ring ${
              emailError ? "border-red-400" : "border-teal-400"
            }`}
          />
          {emailError && (
            <p className="text-xs text-dark-alt mt-1">{emailError}</p>
          )}
        </div>
        <div className="mb-4">
          <label className="block">Subject</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Email Subject"
            className={`w-full border custom-input rounded-md px-3 py-2 focus:outline-none focus:ring ${
              subjectError ? "border-red-500" : "border-teal-400"
            }`}
          />
          {subjectError && (
            <p className="text-xs text-red-500 mt-1">{subjectError}</p>
          )}
        </div>
        <div className="mb-4">
          <label className="block mb-1">Email Body</label>
          <textarea
            id="emailBody"
            value={body}
            onChange={(e) => {
              setBody(e.target.value);
              e.target.style.height = "auto";
              e.target.style.height = `${e.target.scrollHeight}px`;
            }}
            placeholder="Email body"
            className={`w-full border rounded-md px-3 py-2 custom-input focus:outline-none overflow-hidden focus:ring ${
              bodyError ? "border-red-500" : "border-teal-400"
            }`}
            rows="1"
          />
          {bodyError && (
            <p className="text-xs text-red-500 mt-1">{bodyError}</p>
          )}
        </div>
        <div className="flex justify-end gap-4">
          <button onClick={onClose} className="btn-action-white">
            Cancel
          </button>
          <button onClick={handleSend} className="btn-action">
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendInvoiceModal;
